import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { getProfile } from '../../../redux/actions/myAccountAction'
import { SUPPORT_EMAIL } from '../../../utils/config'

interface PaymentFailedProps {
  onTryAgain?: () => void
}

const PaymentFailed: React.FC<PaymentFailedProps> = () => {
  const { t } = useTranslation('plan')
  const navigate = useNavigate()

  const handle = {
    onTryAgain: () => {
      navigate('/setting#plan')
    },
  }

  useEffect(() => {
    getProfile()

    window.dataLayer.push({
      event: 'Payment Failed',
      page: {
        url: location,
        title: 'maayot • Your daily Chinese lesson',
      },
    })
  }, [])

  return (
    <div className='payment-failed-container'>
      <div className='payment-failed-content'>
        <div className='payment-failed-icon'>
          <i className='fa fa-times-circle'></i>
        </div>

        <h2 className='payment-failed-title'>{t('paymentFailed.title')}</h2>

        <p className='payment-failed-message'>{t('paymentFailed.message')}</p>

        <div className='payment-failed-actions'>
          <button className='payment-failed-try-again-btn' onClick={handle.onTryAgain}>
            <i className='fa fa-refresh'></i>
            {t('paymentFailed.back')}
          </button>
        </div>

        <p className='payment-failed-support'>
          <Trans
            t={t}
            i18nKey='paymentFailed.support'
            values={{ email: SUPPORT_EMAIL }}
            components={[<a key='email' href={`mailto:${SUPPORT_EMAIL}`} />]}
          />
        </p>
      </div>
    </div>
  )
}

export default PaymentFailed
